import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AlarmZoneEditorService } from '../../alarm-zone/alarm-zone-editor.service';
import { PlacesAutocompleteDirective } from '../../alarm-zone/places-autocomplete.directive';
import { ZoneLocation } from '../../alarm-zone/alarm-zone.model';

/**
 * Edytor strefy alarmowej: mapa, adres z podpowiedziami, promień i interwał.
 * Sama prezentacja — reguły i stan trzyma AlarmZoneEditorService, ten sam,
 * z którego korzystają ekrany konfiguracji pacjenta.
 */
@Component({
  selector: 'app-alarm-zone',
  templateUrl: './alarm-zone.component.html',
  styleUrls: ['./alarm-zone.component.scss'],
  providers: [AlarmZoneEditorService]
})
export class AlarmZoneComponent implements OnInit {

  @Input() parentFormGroup: FormGroup;

  lat = 52.2431;
  lng = 21.0165;
  zoom = 13;
  icon = {
    url: 'assets/images/customIcon.svg',
    scaledSize: { width: 32, height: 32 }
  };

  @ViewChild(PlacesAutocompleteDirective, { static: false })
  public placesAutocomplete: PlacesAutocompleteDirective;

  constructor(public zoneEditor: AlarmZoneEditorService) {}

  ngOnInit() {
    this.zoneEditor.attach(this.parentFormGroup);

    // Dane strefy przychodzą z API już po utworzeniu komponentu, więc mapa nie może
    // ustawiać się raz na starcie — podąża za współrzędnymi, kiedy się pojawią.
    this.zoneEditor.located.subscribe(location => {
      this.lat = location.latitude;
      this.lng = location.longitude;
      this.zoom = 13;
    });

    // Panel strefy bywa tworzony już po wpisaniu danych z API do formularza
    // (siedzi za *ngIf) — wtedy valueChanges nie wyemituje i mapa zostałaby
    // na domyślnym punkcie, więc centrujemy się na tym, co już jest.
    if (this.zoneEditor.hasCoordinates()) {
      const location = this.zoneEditor.currentLocation();
      this.lat = location.latitude;
      this.lng = location.longitude;
    } else if (!this.zoneEditor.addressValue()) {
      this.setCurrentPosition();
    }
  }

  onZonePlaceSelected(location: ZoneLocation) {
    this.zoneEditor.confirm(location);
  }

  onZoneAddressBlur() {
    if (this.placesAutocomplete && this.placesAutocomplete.consumeSelectionPending()) {
      return;
    }
    this.zoneEditor.resolve().subscribe();
  }

  private setCurrentPosition() {
    if (!('geolocation' in navigator)) {
      return;
    }
    navigator.geolocation.getCurrentPosition(position => {
      // Strefa mogła dojść z API w międzyczasie — nie nadpisujemy jej pozycją urządzenia.
      if (this.zoneEditor.hasCoordinates()) {
        return;
      }
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
      this.zoom = 13;
    });
  }
}
